const React = require('react');
const BackgroundControls = require('./../../controls/background');
const PlainControls = require('./../../controls/plain');
const SignControls = require('./../../controls/sign');

class Personalize extends React.Component {

  constructor (props) {
    super(props);
    this.props = props;

    this.onChange = this.onChange.bind(this);
    this.resetDefaultValues = this.resetDefaultValues.bind(this);
  }

  onChange (name, event) {
    this.props.onChange(name, event.target.value);
    event.preventDefault();
  }

  controls () {
    switch (this.props.template) {
      case 'background':
        return <BackgroundControls {...this.props} onChange={this.onChange} />;
      case 'plain':
        return <PlainControls {...this.props} onChange={this.onChange} />;
      case 'sign':
        return <SignControls {...this.props} onChange={this.onChange} />;
      default:
        throw new Error('Invalid template name');
    }
  }

  resetDefaultValues () {
    $('.color-control input').each((index, $control) => {
      $($control).minicolors('value', this.props.defaults[this.props.template][$control.name]); // #shame.js @TMD
    });
    this.props.resetDefaultValues();
  }


  render () {
    return (
      <div className="step-container step-four">
        <div>
          <h2>Make Them Your Own</h2>
          {this.controls()}
          <small>
            If you get a little too adventurous with your customizations, you can always <a href="#reset-default" onClick={this.resetDefaultValues}>go back to using the default colors</a>.
          </small>
        </div>
      </div>
    );
  }

}

module.exports = Personalize;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/better_error_pages/walk_through/questions/personalize.jsx